import React from 'react';
import { SectionTitle } from './SectionTitle';
import { whatIfQuestions } from '../data/salesCopy';
export function WhatIfSection() {
  return <section className="bg-brand-sand px-4 py-8 sm:py-10" data-id="element-199" data-mp="2i30lmsw6tyzp">
      <div className="mx-auto max-w-3xl" data-id="element-200" data-mp="2e1ykg6ipncv3">
        <SectionTitle data-id="element-201" data-mp="2e3042zdsl7of">Et si vos ressources de Yin Yoga étaient déjà prêtes ?</SectionTitle>

        <p className="mt-4 text-center font-serif text-xl font-bold text-brand-brown sm:text-2xl" data-id="element-202" data-mp="295hvxb7lmwhh">
          Vous savez déjà enseigner.
        </p>
        <p className="mt-1.5 text-center text-[13px] font-medium leading-snug text-brand-brown/85 sm:text-[15px]" data-id="element-203" data-mp="31rsukgbnanbn">
          Le problème, c’est de devoir constamment trouver les bonnes postures,
          séquences et variations pour préparer votre prochain cours.
        </p>

        <ul className="mt-4 space-y-1.5" data-id="element-204" data-mp="3phwxelh0ej1l">
          {whatIfQuestions.map(q => <li key={q} className="rounded border-l-4 border-brand-gold bg-brand-ivory px-3 py-2 text-[13px] font-semibold leading-snug text-brand-brown sm:text-sm" data-id="element-205" data-mp="3pjzyc0jp9wl3">
              {q}
            </li>)}
        </ul>

        <p className="mt-4 text-[13px] font-medium leading-snug text-brand-brown/85 sm:text-[15px]" data-id="element-206" data-mp="39lrnfkiua3d8">
          Au lieu de chercher dans des ressources dispersées,{' '}
          <strong className="font-bold text-brand-brown" data-id="element-207" data-mp="2zwrjrnte6jsp">YIN YOGA PRO™</strong>{' '}
          vous donne une bibliothèque organisée de ressources visuelles et prêtes
          à utiliser dans 6 domaines essentiels de l’enseignement du Yin Yoga.
        </p>
        <p className="mt-3 text-center font-serif text-lg font-bold uppercase tracking-wide text-brand-sage sm:text-xl" data-id="element-208" data-mp="2quib73hop0hy">
          Choisissez. Structurez. Adaptez. Enseignez.
        </p>
      </div>
    </section>;
}